import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import './CategoryMenu.css';

const CategoryMenu = ({ isOpen, onClose }) => {
  const [categories, setCategories] = useState([]);
  const [activeCategory, setActiveCategory] = useState(null);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCategories = async () => {
      let data;
      try {
        const response = await axios.get('https://earnistamart.online/getcategories');
        data=response;
        setCategories(response.data.posts);
      } catch (error) {
        console.error('Error fetching data: ', error);
        setError(error.message);
      }
      console.error('Data that is fetching : ', data);
    };

    if (isOpen) {
      fetchCategories();
    }
  }, [isOpen]);

  const handleCategoryClick = (categoryName) => {
    navigate('/products', {
      state: {
        selectedCategory: categoryName,
        selectedSubcategory: null, // Ensure subcategory is null when category is selected
      },
    });
    onClose();
  };

  const handleSubcategoryClick = (subcategoryName) => {
    navigate('/products', {
      state: {
        selectedCategory: null, // Ensure category is null when subcategory is selected
        selectedSubcategory: subcategoryName,
      },
    });
    console.log("subcategory send from the category was , ", subcategoryName);
    onClose();
  };

  const renderCategories = () => {
    return categories.map((category) => (
      <li
        key={category._id}
        className={`category-item ${activeCategory && activeCategory._id === category._id ? 'active' : ''}`}
        onMouseEnter={() => setActiveCategory(category)}
      >
        <span onClick={() => handleCategoryClick(category.name)}>
          {category.name}
        </span>
      </li>
    ));
  };

  const renderSubcategories = () => {
    if (!activeCategory || !activeCategory.subcategories) {
      return null;
    }
    return (
      <ul className="subcategory-list">
        {activeCategory.subcategories.map((subcategory, index) => (
          <li key={index} className="subcategory-item">
            <span onClick={() => handleSubcategoryClick(subcategory.name)}>
              {subcategory.name}
            </span>
          </li>
        ))}
      </ul>
    );
  };

  if (!isOpen) return null;

  return (
    <div className="overlay" onClick={onClose}>
      <div
        className="category-menu-container"
        onMouseLeave={() => setActiveCategory(null)}
        onClick={(e) => e.stopPropagation()}
      >
        {error && <div className="error-message">{error}</div>}
        <div className="category-menu">
          <ul className="category-list">{renderCategories()}</ul>
        </div>
        <div className="subcategory-menu">{renderSubcategories()}</div>
        <button onClick={onClose} className="close-category-menu">
          Close
        </button>
      </div>
    </div>
  );
};

export default CategoryMenu;
